import React, {useEffect, useState} from "react";
import apiRequests from "../../Component/axios/config/config";
import WebLogo from "../../font & image/image/favicon.png";
import searchIcon from "../../font & image/image/search-normal.svg";
import toast from "react-hot-toast";
import Loading from "../../Component/Loading/Loading";
import {FaAngleLeft, FaAngleRight} from "react-icons/fa";
import {Pencil} from "lucide-react";
import {useNavigate} from "react-router-dom";
import logo from "../../font & image/image/clansmartLogo.svg";
import shoppingIcon from "../../font & image/image/shopping-bag-header.svg";

export default function AllBanners() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    const [pathSelected, setPathSelected] = useState("MAIN");

    const paths = [
        {name: "home", Type: "MAIN"},
        {name: "Grocery Store", Type: "PRODUCT"},
        {name: "Order Food", Type: "FOOD"},
    ]


    useEffect(() => {
        setLoading(true);

        apiRequests.get(`/api/banner/get-all`,
            {
                params: {
                    is_slide: true,
                    Type: pathSelected
                }
            })
            .then((response) => {
                setBanners(response.data.data);
                setCurrentIndex(0);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                toast.error("Failed to get all banners");
                setBanners([]);
            })
            .finally(() => setLoading(false));
    }, [pathSelected]);


    return (
        <div className="grid gap-4 p-6">
            <div className="flex gap-4 items-center justify-between">
                <div className="text-3xl font-bold text-gray-800">
                    All Banners
                </div>
                <div className={`w-fit flex justify-center gap-12 items-center md:gap-4 sm:hidden`}>

                    {paths.map((item, index) => {

                        return (
                            <button
                                onClick={() => {
                                    setPathSelected(item.Type)
                                }}
                                key={index}
                                className={`${pathSelected === item.Type ? "border-b border-[#FF8C42] text-[#FF8C42]" : "text-black border-none"} text-lg sm:text-[16px] font-bold`}
                            >
                                {item.name}
                            </button>
                        )
                    })}

                </div>

                <div className="flex flex-col sm:flex-row justify-between gap-4">
                    <div className="flex gap-2">
                        <button
                            onClick={() => navigate("edit-Banners" + `?Type=${pathSelected}`)}
                            className="flex items-center bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg gap-2"
                        >

                            <Pencil className="w-4 h-4"/>
                            Edit Banner

                        </button>
                    </div>
                </div>
            </div>
            <div className={`w-full justify-evenly items-center md:gap-4 hidden sm:flex`}>

                {paths.map((item, index) => {

                    return (
                        <button
                            onClick={() => {
                                setPathSelected(item.Type)
                            }}
                            key={index}
                            className={`${pathSelected === item.Type ? "border-b border-[#FF8C42] text-[#FF8C42]" : "text-black border-none"} text-lg sm:text-[16px] font-bold`}
                        >
                            {item.name}
                        </button>
                    )
                })}

            </div>


            {loading ? (
                <div className="py-10">
                    <Loading/>
                </div>
            ) : (
                banners.length > 0 ? (
                    banners.map((banner, index) => (
                        index === currentIndex && (
                            <RenderBanners banner={banner} currentIndex={currentIndex} setCurrentIndex={setCurrentIndex}
                                           bannerLength={banners.length} path={pathSelected}/>
                        )
                    ))
                ) : (
                    <p className="w-full text-center text-xl py-10 text-gray-500 font-bold">
                        No banners found.
                    </p>
                )
            )}

        </div>
    );
}


function RenderBanners({banner, currentIndex, setCurrentIndex, bannerLength, path}) {


    const sitePaths = [
        {Type:"MAIN" ,link: "/", name: "home"},
        {Type:"PRODUCT" ,link: "/groceryStore", name: "Grocery Store"},
        {Type:"FOOD" ,link: "/orderFood", name: "Order Food"},
    ]

    return (
        <div className="relative">

            {!banner?.is_automatic && (
                <div className="mt-6 flex flex-col gap-8">
                    <div
                        className={`flex flex-col gap-[5.5rem] sm:gap-4 border border-gray-400 py-4 rounded-xl`}>

                        <nav className="flex justify-between items-center gap-2 px-12 py-6 sm:flex-row md:px-3">
                            <div className="flex gap-5 justify-center items-center">
                                {/*<button*/}
                                {/*    className="text-[32px] flex items-center justify-centers text-buttonColor-shade8"*/}
                                {/*    onClick={() => setShowModalHeaterDesktop(true)}*/}
                                {/*>*/}
                                {/*    <div*/}
                                {/*        className="flex flex-col gap-1.5 p-2 border border-black rounded-xl border-grey-shade9 sm:bg-transparent sm:border-transparent">*/}
                                {/*        <IoMenuOutline/>*/}
                                {/*    </div>*/}
                                {/*</button>*/}
                                <div className="md:hidden">
                                    <img src={logo} alt="" className="min-w-full"/>
                                </div>
                                <div className="text-4xl text-grey-shade9 font-extrabold md:hidden ">
                                    Clans Smart
                                </div>
                                <div className="p-1 rounded-xl relative border border-black md:hidden">
                                    <div>
                                        <img src={shoppingIcon} alt="" className="min-h-4 min-w-4" width={35}
                                             height={35}/>
                                    </div>

                                </div>

                                <div className="relative flex gap-3 w-fit md:w-full">
                                    <img
                                        width={20}
                                        height={20}
                                        src={searchIcon}
                                        alt=""
                                        className="absolute top-3 left-[17px] sm:left-2.5 sm:top-2.5 cursor-pointer transition-all duration-300 hover:scale-125"
                                    />
                                    {/*<Image*/}
                                    {/*    width={20}*/}
                                    {/*    height={20}*/}
                                    {/*    src={filterMobile}*/}
                                    {/*    alt=""*/}
                                    {/*    className="hidden sm:block absolute top-3 right-4 cursor-pointer transition-all duration-300 hover:scale-125"*/}
                                    {/*/>*/}
                                    {/*<button*/}
                                    {/*    className="absolute top-3 right-5"*/}
                                    {/*>*/}
                                    {/*    <FaTimes size={20}*/}
                                    {/*             className={`transition-colors duration-200 hover:text-red-500 ${openSearch ? "block" : "hidden"}`}/>*/}
                                    {/*</button>*/}


                                </div>
                            </div>


                            <div
                                className={`w-fit flex justify-center gap-12 items-center md:gap-4 sm:justify-between"}`}>

                                {sitePaths.map((item, index) => {

                                    return (

                                        <div key={index}
                                             className={`${path === item.Type ? "border-b border-[#FF8C42] text-[#FF8C42]" : "text-black border-none"} text-lg sm:text-[16px] font-bold`}>
                                            {item.name}
                                        </div>
                                    )
                                })}

                            </div>

                        </nav>

                        <div
                            className="relative text-grey-shade1 flex justify-between w-full h-[414px] sm:w-[95%]  sm:rounded-[2rem] sm:mx-auto sm:h-48 sm:p-9">

                            <button
                                className={`z-50 absolute top-44 left-2 bg-gray-200 p-2 rounded-lg ${currentIndex === 0 && "opacity-30 cursor-not-allowed"}`}
                                onClick={() => {
                                    if (currentIndex !== 0) {
                                        setCurrentIndex(currentIndex - 1)
                                    }
                                }}
                                disabled={currentIndex === 0}
                            >
                                <FaAngleLeft className="text-black" size={40}/>
                            </button>

                            <img
                                src={banner.image ? `${process.env.REACT_APP_API_URL}${banner.image.path}` : "none"}
                                className="min-w-full"
                                alt=""
                            />

                            <button
                                className={`z-50 absolute top-44 right-2 bg-gray-200 p-2 rounded-lg ${bannerLength - 1 === currentIndex && "opacity-30 cursor-not-allowed"}`}
                                onClick={() => {
                                    if (bannerLength !== currentIndex) {
                                        setCurrentIndex(currentIndex + 1)
                                    }
                                }}
                                disabled={bannerLength - 1 === currentIndex}
                            >
                                <FaAngleRight className="text-black" size={40}/>
                            </button>

                        </div>


                    </div>

                </div>
            )}

            {banner?.is_automatic && (
                <div className="flex flex-col gap-8">
                    <div className={`flex flex-col gap-[5.5rem] rounded-xl sm:gap-4 border border-gray-400 py-4`}>
                        <nav className="flex justify-between items-center gap-2 px-12 py-6 sm:flex-row md:px-3">
                            <div className="flex gap-5 justify-center items-center">
                                {/*<button*/}
                                {/*    className="text-[32px] flex items-center justify-centers text-buttonColor-shade8"*/}
                                {/*    onClick={() => setShowModalHeaterDesktop(true)}*/}
                                {/*>*/}
                                {/*    <div*/}
                                {/*        className="flex flex-col gap-1.5 p-2 border border-black rounded-xl border-grey-shade9 sm:bg-transparent sm:border-transparent">*/}
                                {/*        <IoMenuOutline/>*/}
                                {/*    </div>*/}
                                {/*</button>*/}
                                <div className="md:hidden">
                                    <img src={logo} alt="" className="min-w-full"/>
                                </div>
                                <div className="text-4xl text-grey-shade9 font-extrabold md:hidden ">
                                    Clans Smart
                                </div>
                                <div className="p-1 rounded-xl relative border border-black md:hidden">
                                    <div>
                                        <img src={shoppingIcon} alt="" className="min-h-4 min-w-4" width={35}
                                             height={35}/>
                                    </div>

                                </div>

                                <div className="relative flex gap-3 w-fit md:w-full">
                                    <img
                                        width={20}
                                        height={20}
                                        src={searchIcon}
                                        alt=""
                                        className="absolute top-3 left-[17px] sm:left-2.5 sm:top-2.5 cursor-pointer transition-all duration-300 hover:scale-125"
                                    />
                                    {/*<Image*/}
                                    {/*    width={20}*/}
                                    {/*    height={20}*/}
                                    {/*    src={filterMobile}*/}
                                    {/*    alt=""*/}
                                    {/*    className="hidden sm:block absolute top-3 right-4 cursor-pointer transition-all duration-300 hover:scale-125"*/}
                                    {/*/>*/}
                                    {/*<button*/}
                                    {/*    className="absolute top-3 right-5"*/}
                                    {/*>*/}
                                    {/*    <FaTimes size={20}*/}
                                    {/*             className={`transition-colors duration-200 hover:text-red-500 ${openSearch ? "block" : "hidden"}`}/>*/}
                                    {/*</button>*/}


                                </div>
                            </div>


                            <div
                                className={`w-fit flex justify-center gap-12 items-center md:gap-4 sm:justify-between"}`}>

                                {sitePaths.map((item, index) => {

                                    return (

                                        <div key={index}
                                             className={`${path === item.Type ? "border-b border-[#FF8C42] text-[#FF8C42]" : "text-black border-none"} text-lg sm:text-[16px] font-bold`}>
                                            {item.name}
                                        </div>
                                    )
                                })}

                            </div>

                        </nav>

                        <div
                            style={{backgroundImage: `url(${process.env.REACT_APP_API_URL}${banner?.cover?.path})`}}
                            className={`relative text-grey-shade1 flex justify-between px-12 w-full h-[414px] sm:w-[95%] bg-cover bg-no-repeat sm:bg-[linear-gradient(110.4deg,#FF731A_0%,#FF731A_20%,#FFD0B3_150%)] sm:rounded-[2rem] sm:mx-auto sm:h-48 sm:p-9`}>
                            <button
                                className={`z-50 absolute top-44 left-2 bg-gray-200 p-2 rounded-lg ${currentIndex === 0 && "opacity-30 cursor-not-allowed"}`}
                                onClick={() => {
                                    if (currentIndex !== 0) {
                                        setCurrentIndex(currentIndex - 1)
                                    }
                                }}
                                disabled={currentIndex === 0}
                            >
                                <FaAngleLeft className="text-black" size={40}/>
                            </button>

                            <div
                                className="flex flex-col sm:items-center sm:justify-center py-24 gap-10 pl-24 w-[50%] sm:p-0 md:w-full md:pl-4 md:pt-32 sm:gap-5">
                                <h3 className="flex justify-start w-full text-[48px] font-bold sm:text-xl">
                                    {banner.header}
                                </h3>
                                <p className="w-full text-lg sm:text-[12px] sm:leading-4">
                                    {banner.body}
                                </p>
                            </div>
                            {banner.image &&
                                <div className="w-[40%] sm:w-[100%] flex items-center justify-center -mr-10">
                                    <img
                                        width={400}
                                        height={580}
                                        src={banner.image ? `${process.env.REACT_APP_API_URL}${banner.image.path}` : "none"}
                                        alt=""
                                    />
                                </div>
                            }

                            <button
                                className={`z-50 absolute top-44 right-2 bg-gray-200 p-2 rounded-lg ${bannerLength - 1 === currentIndex && "opacity-30 cursor-not-allowed"}`}
                                onClick={() => {
                                    if (bannerLength - 1 !== currentIndex) {
                                        setCurrentIndex(currentIndex + 1)
                                    }
                                }}
                                disabled={bannerLength - 1 === currentIndex}
                            >
                                <FaAngleRight className="text-black" size={40}/>
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}